import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/AcquireFlowHero';
import { Testimonial } from './components/AcquireFlowHerovideo';
import { HowItWorksSection } from './components/AcquireFlowFeatureSectionv2';
import { ROICalculator } from './components/ROICalculator';
import { FeatureSectionV3 } from './components/AcquireFlowFeatureSectionv3';
import { FeatureComparison } from './components/AcquireFlowFeatureComparison1';
import { Testimonials } from './components/AcquireFlowTestimonials';
import { FounderStory } from './components/AcquireFounderStory';
import { PricingSection } from './components/AcquireFlowPricing';
import { FAQSection } from './components/AcquireFAQSection';
import { SecurityCTA } from './components/AcquireFlowSecurityCTA';
import { Footer } from './components/AcquireFooter';
import { SEOHead } from './components/SEO/SEOHead';
import { CurvedDivider, ScrollProgress, ActivityNotification } from './components/shared';
import { generateHomepageSchema } from './utils/structuredData';
// Import data
import { testimonials } from './data/testimonials';
import { pricingPlans } from './data/pricingPlans';
import { comparisonFeatures } from './data/featureComparison';
export function App() {
  return <>
      {/* SEO Meta Tags and Structured Data */}
      <SEOHead structuredData={generateHomepageSchema()} data-id="element-0" />

      {/* Scroll Progress Indicator */}
      <ScrollProgress data-id="element-1" />

      {/* Activity Notification Popup */}
      <ActivityNotification data-id="element-2" />

      <div className="flex flex-col min-h-screen" data-id="element-3">
        <Navbar data-id="element-4" />
        <main className="flex-grow" data-id="element-5">
          {/* Hero Section - Dark Background */}
          <section className="relative w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] overflow-hidden" data-id="element-6">
            <Hero data-id="element-7" />
          </section>

          {/* Curved Divider: Dark to Light */}
          <CurvedDivider direction="dark-to-light" data-id="element-8" />

          {/* Testimonial Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-9">
            <Testimonial userName="Marcus Thompson" userTitle="Real Estate Investor, Thompson Properties" imageUrl="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" buttonText="Watch Demo" onButtonClick={() => console.log('Video clicked')} data-id="element-10" />
          </section>

          {/* How It Works Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-11">
            <HowItWorksSection data-id="element-12" />
          </section>

          {/* Curved Divider: Light to Dark */}
          <CurvedDivider direction="light-to-dark" data-id="element-13" />

          {/* Key Features Section V3 - Dark */}
          <FeatureSectionV3 data-id="element-14" />

          {/* ROI Calculator Section - Dark */}
          <ROICalculator data-id="element-15" />

          {/* Curved Divider: Dark to Light */}
          <CurvedDivider direction="dark-to-light" data-id="element-16" />

          {/* Success Stories Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-17">
            <Testimonials title="Success Stories" subtitle="What Says Our Clients" description="Join 200+ investors who are closing more deals with AcquireFlow. Here's what they have to say about their experience." testimonials={testimonials} data-id="element-18" />
          </section>

          {/* Founder Story Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-19">
            <FounderStory data-id="element-20" />
          </section>

          {/* Curved Divider: Light to Dark */}
          <CurvedDivider direction="light-to-dark" data-id="element-21" />

          {/* Feature Comparison Section - Dark */}
          <FeatureComparison title="Unlock Massive Leverage: MLS Offer Volume No Team Could Ever Match." subtitle="AcquireFlow automates your entire outreach process with AI-powered targeting, bulk offer sending, and real-time follow-up — giving you more deal flow than cold calling, ads, or direct mail ever could." badge="AcquireFlow vs Traditional Marketing" brandName="AcquireFlow" competitorLabels={['Cold Calling', 'Ads', 'Direct Mail']} features={comparisonFeatures} ctaText="Start with AcquireFlow" ctaHref="#pricing" data-id="element-22" />

          {/* Pricing Section - Dark Background with ID anchor */}
          <section id="pricing" className="relative w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] overflow-hidden" data-id="element-23">
            <PricingSection title="Pricing & Plans" subtitle="Invest in Your Deal Flow" description="One closed deal pays for a year of AcquireFlow. Most investors close their first deal within 60 days." plans={pricingPlans} data-id="element-24" />
          </section>

          {/* Curved Divider: Dark to Light */}
          <CurvedDivider direction="dark-to-light" data-id="element-25" />

          {/* FAQ Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-26">
            <FAQSection data-id="element-27" />
          </section>

          {/* Curved Divider: Light to Dark */}
          <CurvedDivider direction="light-to-dark" data-id="element-28" />

          {/* Security CTA Section - Dark Background */}
          <section className="relative w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] overflow-hidden" data-id="element-29">
            <SecurityCTA data-id="element-30" />
          </section>
        </main>
        <Footer data-id="element-31" />
      </div>
    </>;
}